import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=424f0df4&scoped=true"
import script from "./shop.vue?vue&type=script&lang=ts"
export * from "./shop.vue?vue&type=script&lang=ts"
import style0 from "./shop.vue?vue&type=style&index=0&id=424f0df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f0df4",
  null
  
)

export default component.exports